<template>
    <div class="card mb-0">
        <div class="card-content">
            <div class="card-body">
                <h4>Savol turi: Ketma ketlikni belgilash</h4>
                <h4 class="d-flex align-items-center">
                    Savol: <span v-html="question.question" style="margin-top: 13px; margin-left: 8px;"></span>
                </h4>
                <h4>Балл: {{ question.ball }}</h4>
                <h4 style="margin-top: 13px;">Ответы: </h4>
                <ul class="list-group mb-1">
                    <li class="list-group-item pb-0" v-for="(answer, index) in answers">
                        <div class="d-flex align-items-center">
                            <div class="mb-1">{{ index+1 }}. </div>
                            <div v-html="answer.answer">
                            </div>
                        </div>
                    </li>
                </ul>
                <button class="btn btn-outline-primary waves-effect waves-light" data-dismiss="modal">
                    Назад
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SetupSequencesModal",
        props: {
            question: Object,
            answers: Array
        },
    }
</script>

<style scoped>

</style>